import styled from "styled-components"
import { theme } from "../../Mixin"
import ContactUsForm from "./ContactUsForm"
import { SolutionNames, SolutionPlans } from "@/common/data/Products"

interface ContactUsSectionProps {
  /**
   * @description  use this like title
   */
  description?: string
  slogan?: string
  body?: string
  page: SolutionNames
  plans?: SolutionPlans[]
}

export default function ContactUsSection({
  description,
  slogan,
  body,
  page,
  plans
}: ContactUsSectionProps) {
  return (
    <Wrapper id="contactUsSection" className="kg-wrapper">
      <LeftWrapper>
        {description && (
          <DescWrapper className="title">{description}</DescWrapper>
        )}
        {slogan && <SloganWrapper>{slogan}</SloganWrapper>}
        {body && <BodyWrapper className="body">{body}</BodyWrapper>}
      </LeftWrapper>
      <RightWrapper>
        <ContactUsForm page={page} maxHeight="650px" plans={plans} />
      </RightWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding-top: 8vh;
  gap: 24px;
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  overflow: hidden;
  width: 100%;
  align-items: flex-start;

  @media only screen and (${theme.lg}) {
    width: 100%;
    display: flex;
    max-height: auto;
    flex-direction: column;
    height: auto;
    justify-content: center;
    align-items: center;
  }
`

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const DescWrapper = styled.div`
  color: ${theme.color.primary};
`

const SloganWrapper = styled.h2`
  color: ${theme.color.textContrast};
`

const BodyWrapper = styled.div`
  color: ${theme.color.textDisabled};
`

const RightWrapper = styled.div`
  width: 100%;
`
